import ReactotronManager from "./ReactotronManager_web"
export default ReactotronManager
